import { makeStyles } from '@mui/styles';
const tooltipModalStyles = makeStyles(() => ({
    dialog: {
        paddingTop: 10,
    },
    dialogContent: {},
}), { name: 'Common_TooltipModal' });
export default tooltipModalStyles;
//# sourceMappingURL=tooltipModal.styles.js.map